/* Copyright 2016-2022
   Kabandy
   Author: Cedric Hoarau
 */

import { ITime, ITimeSerialized } from ".";

export module ModelGroupFilters {
    export enum EDefaultFiltersType {
        Physical = "physical",
        Room = "room"
    }

    export interface IDefaultFilter {
        id: string;
        propertyName: string;
        room: boolean;
        physical: boolean;
        isCustom: boolean;
    }

    export interface IDefaultFilters {
        id: EDefaultFiltersType;
        userId: string;
        projectId: string;
        modelgroupId: string;
        filters: IDefaultFilter[];
        time: ITime | ITimeSerialized;
    }

    export interface IDefaultFiltersCopyInfo {
        userId: string;
        filterId: string;
        projectIdSrc: string;
        modelgroupIdSrc: string;
        projectIdDest: string;
        modelgroupIdDest: string;
    }

    export interface IDefaultFiltersCreateInfo {
        userId: string;
        filterId: string;
        projectId: string;
        modelgroupId: string;
        filters: IDefaultFilter[];
    }

    export interface IDefaultFiltersDeleteInfo {
        filterId: string;
        projectId: string;
        modelgroupId: string;
    }

    export interface IDefaultFiltersGetInfo {
        filterId: string;
        projectId: string;
        modelgroupId: string;
    }
}
